
// ------------- old code ----------------------
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import PredefinedDateRanges from '../../../core/common/datePicker'
import Table from "../../../core/common/dataTable/index";
// import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import AXIOSCONFIGMETHOD from '../../../Axios/axiosConfigMethod'
// import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import { webServiceUrl } from '../../../core/api_utils/webserviceUrl'
// import { leadsDataList } from '../../../core/data/json/leadsList'
// import CrmsModal from '../../../core/modals/crms_modal'
import { leadsDataList } from '../../../core/data/json/leadsList'
import axios from 'axios'
import CustomeLoader from '../../../core/common/customeLoader/CustomeLoader'
import Loading from '../../../core/common/custom-loading/Loading'
import dayjs from "dayjs";


const SalesPersonLeadList = () => {
  const [loading, setLoading] = useState<any>([])
  const [state, setState] = useState<any>([]);
  const location = useLocation();
  const staff_employee_id = location.state?.employeeId;
  //   console.log("vcvvvvvvvvvvvvvvvvvvvvvvvvvvvvv", staff_employee_id)



  const getAllLead = async () => {
    setLoading(true)
    try {
      const payload = {
        "staff_employee_id": staff_employee_id
      }
      const response = await AXIOSCONFIGMETHOD("post", webServiceUrl.SALES_LEAD_LIST, payload);
      console.log("Response: by arjun kumar", response?.data);
      setState(response?.data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getAllLead();
  }, []);


  const navigate = useNavigate();
  const routes = all_routes;
  // const data = leadsDataList;

const columns = [
  // --- Lead Info ---
  {
    title: "Lead Name",
    dataIndex: "name",
    sorter: (a: any, b: any) => a.name.length - b.name.length,
  },
  {
    title: "Structure Type",
    dataIndex: "structure_type",
    sorter: (a: any, b: any) => a.structure_type.length - b.structure_type.length,
  },
  {
    title: "Stage",
    dataIndex: "lead_stage",
    render: (text: string) => (
      <span
        className={`badge ${
          text === "WON"
            ? "badge-success-transparent"
            : text === "FOLLOWUP"
            ? "badge-warning-transparent"
            : text === "LOST"
            ? "badge-danger-transparent"
            : "badge-secondary-transparent"
        }`}
      >
        {text}
      </span>
    ),
    sorter: (a: any, b: any) => a.lead_stage.length - b.lead_stage.length,
  },
  {
    title: "Business Type",
    dataIndex: "business_type",
    sorter: (a: any, b: any) => a.business_type.length - b.business_type.length,
  },

  // --- Contact Info ---
  {
    title: "Mobile No",
    dataIndex: "mobile_no",
    sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
  },
  {
    title: "Email",
    dataIndex: "email_id",
    sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
  },
  {
    title: "Gender",
    dataIndex: "gender",
    sorter: (a: any, b: any) => a.gender.length - b.gender.length,
  },

  // --- Location Info ---
  {
    title: "Locality",
    dataIndex: "locality",
    sorter: (a: any, b: any) => a.locality.length - b.locality.length,
  },
  {
    title: "City",
    dataIndex: "city",
    sorter: (a: any, b: any) => a.city.length - b.city.length,
  },

  // --- Lead Source / Product ---
  {
    title: "Source Type",
    dataIndex: "source_type",
    sorter: (a: any, b: any) => a.source_type.length - b.source_type.length,
  },
  {
    title: "Product",
    dataIndex: "number_of_beds",
    sorter: (a: any, b: any) => a.number_of_beds.length - b.number_of_beds.length,
  },

  // --- Budget ---
{
  title: "Min Budget",
  dataIndex: "budget_min_preference",
  key: "budget_min_preference",
  render: (value: number) => (value ? `₹${value.toLocaleString("en-IN")}` : "-"),
  sorter: (a: any, b: any) => (a.budget_min_preference || 0) - (b.budget_min_preference || 0),
},
{
  title: "Max Budget",
  dataIndex: "budget_max_preference",
  key: "budget_max_preference",
  render: (value: number) => (value ? `₹${value.toLocaleString("en-IN")}` : "-"),
  sorter: (a: any, b: any) => (a.budget_max_preference || 0) - (b.budget_max_preference || 0),
},


  // --- Timeline ---
{
  title: "Created On",
  dataIndex: "created_on",
  sorter: (a: { created_on?: string }, b: { created_on?: string }) =>
    new Date(a.created_on || 0).getTime() - new Date(b.created_on || 0).getTime(),
  render: (value: string | undefined) =>
    value ? dayjs(value).format("DD-MM-YYYY, hh:mm A") : "N/A",
}
,

  // --- Actions ---
  {
    title: "Trails",
    dataIndex: "FollowupTrail",
    width: 150,
    render: (_: any, record: any) => (
      <button
        onClick={() => {
          navigate("/follow-up-trail", {
            state: { lead_id: record.lead_account_id },
          });
        }}
        className="btn btn-sm w-100"
        style={{ whiteSpace: "nowrap", background: "#6b7280", color: "white" }}
      >
        Followup Trail
      </button>
    ),
  },
];

//   const columns = [
//   // --- Lead Info ---
//   {
//     title: "Lead Name",
//     dataIndex: "name",
//     sorter: (a: any, b: any) => a.name.length - b.name.length,
//   },
//   {
//     title: "Structure Type",
//     dataIndex: "structure_type",
//     sorter: (a: any, b: any) => a.structure_type.length - b.structure_type.length,
//   },
//   {
//     title: "Stage",
//     dataIndex: "lead_stage",
//     render: (text: string) => (
//       <span
//         className={`badge ${
//           text === "WON"
//             ? "badge-success-transparent"
//             : text === "FOLLOWUP"
//             ? "badge-warning-transparent"
//             : text === "LOST"
//             ? "badge-danger-transparent"
//             : "badge-secondary-transparent"
//         }`}
//       >
//         {text}
//       </span>
//     ),
//     sorter: (a: any, b: any) => a.lead_stage.length - b.lead_stage.length,
//   },

//   // --- Contact Info ---
//   {
//     title: "Mobile No",
//     dataIndex: "mobile_no",
//     sorter: (a: any, b: any) => a.mobile_no.length - b.mobile_no.length,
//   },
//   {
//     title: "Email",
//     dataIndex: "email_id",
//     sorter: (a: any, b: any) => a.email_id.length - b.email_id.length,
//   },
//   {
//     title: "Gender",
//     dataIndex: "gender",
//     sorter: (a: any, b: any) => a.gender.length - b.gender.length,
//   },

//   // --- Location Info ---
//   {
//     title: "Locality",
//     dataIndex: "locality",
//     sorter: (a: any, b: any) => a.locality.length - b.locality.length,
//   },
//   {
//     title: "City",
//     dataIndex: "city",
//     sorter: (a: any, b: any) => a.city.length - b.city.length,
//   },

//   // --- Lead Source / Product ---
//   {
//     title: "Source Type",
//     dataIndex: "source_type",
//     sorter: (a: any, b: any) => a.source_type.length - b.source_type.length,
//   },
//   {
//     title: "Product",
//     dataIndex: "number_of_beds",
//     sorter: (a: any, b: any) => a.number_of_beds.length - b.number_of_beds.length,
//   },

//   // --- Budget ---
//   {
//     title: "Min Budget",
//     dataIndex: "budget_min_preference",
//     sorter: (a: any, b: any) => a.budget_min_preference - b.budget_min_preference,
//     render: (value: number) => value?.toLocaleString("en-IN") ?? "-",
//   },
//   {
//     title: "Max Budget",
//     dataIndex: "budget_max_preference",
//     sorter: (a: any, b: any) => a.budget_max_preference - b.budget_max_preference,
//     render: (value: number) => value?.toLocaleString("en-IN") ?? "-",
//   },

//   // --- Actions ---
//   {
//     title: "Trails",
//     dataIndex: "FollowupTrail",
//     width: 150,
//     render: (_: any, record: any) => (
//       <button
//         onClick={() => {
//           navigate("/follow-up-trail", {
//             state: { lead_id: record.lead_account_id },
//           });
//         }}
//         className="btn btn-sm w-100"
//         style={{ whiteSpace: "nowrap", background: "#6b7280", color: "white" }}
//       >
//         Followup Trail
//       </button>
//     ),
//   },
// ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Sales Person Lead List </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item"> <Link to={routes.leaddashboard}>
                    Dashboard
                  </Link></li>
                  <li className="breadcrumb-item active" aria-current="page">

                    Sales Person Lead List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <Link
                to={`/sales-team`}
                className="btn btn-sm me-1"
                style={{ whiteSpace: 'nowrap', background: '#6b7280', color: 'white' }}
              >
                Back
              </Link>
              {/* <button className='btn btn-sm' style={{ whiteSpace: 'nowrap', background: "#6b7280", color: "white" }}>back</button> */}
              {/* <div className="me-2 mb-2">
                   <div className="dropdown">
                     <Link
                       to="#"
                       className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                       data-bs-toggle="dropdown"
                     >
                       <i className="ti ti-file-export me-1" />
                       Export
                     </Link>
                     <ul className="dropdown-menu  dropdown-menu-end p-3">
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-pdf me-1" />
                           Export as PDF
                         </Link>
                       </li>
                       <li>
                         <Link
                           to="#"
                           className="dropdown-item rounded-1"
                         >
                           <i className="ti ti-file-type-xls me-1" />
                           Export as Excel{" "}
                         </Link>
                       </li>
                     </ul>
                   </div>
                 </div> */}
              {/* <div className="input-icon mb-2 position-relative">
                   <PredefinedDateRanges />
                 </div> */}
              <div className="ms-2 head-icons">
                <CollapseHeader />
              </div>

            </div>

          </div>
          {/* <button className='btn btn-sm text-end' style={{background: "#6b7280", color: "white" }}>back</button> */}

          {/* /Breadcrumb */}
          {/* Leads List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5> Sales Lead List  </h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* <div className="me-3">
              <div className="input-icon-end position-relative">
                <PredefinedDateRanges/>
                <span className="input-icon-addon">
                  <i className="ti ti-chevron-down" />
                </span>
              </div>
            </div> */}
                <div className="dropdown me-3">
                  {/* <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Tags
              </Link> */}
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Closed
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Contacted
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Lost
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="dropdown-item rounded-1"
                      >
                        Not Contacted
                      </Link>
                    </li>
                  </ul>
                </div>
                {/* <div className="dropdown">
              <Link
                to="#"
                className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : Last 7 Days
              </Link>
              <ul className="dropdown-menu  dropdown-menu-end p-3">
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Recently Added
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Ascending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Desending
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last Month
                  </Link>
                </li>
                <li>
                  <Link
                    to="#"
                    className="dropdown-item rounded-1"
                  >
                    Last 7 Days
                  </Link>
                </li>
              </ul>
            </div> */}
              </div>
            </div>

            {
              loading ? (
                <Loading />
              ) : (
                <div className="card-body p-0">
                  <Table dataSource={state} columns={columns} Selection={false} />
                </div>
              )
            }

          </div>
          {/* /Leads List */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">{new Date().getFullYear()} © Nestfin Technology. All rights reserved.</p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* <CrmsModal/> */}
    </>

  )
}

export default SalesPersonLeadList